import styled from "styled-components";
import { theme } from "@themes";

export const GeneralContainer = styled.div`
  display: flex;
  width: auto;
  background-color: ${({ theme }) => theme.primaryBackgroundLight};
`;

export const ContentForm = styled.div`
  padding: 3em 7em 0em 10em;
  margin: 1em 1em 0em 4em;
  text-align: center;
  width: 60vw;
  height: 100vh;
  background-color: ${({ theme }) => theme.secondaryGrayLightNine};
  overflow-y: auto;
  &::-webkit-scrollbar {
    width: 0.3em;
  }
  &::-webkit-scrollbar-thumb {
    background: ${({ theme }) => theme.neutral.gray[1000]};
    border-radius: 3px;
    border: 1px solid #c7b9c475;
  }
  &::-webkit-scrollbar-track {
    box-shadow: inset 0 0 5px #fdfdfd73;
    border-radius: 10px;
  }
`;

export const ContentComments = styled.div`
  background-color: ${({ theme }) => theme.primaryBackgroundLight};
  width: 40vw;
  height: fit-content;
`;

export const Content = styled.div`
  background-color: ${({ theme }) => theme.primaryBackgroundLight};
  border: 1px solid ${({ theme }) => theme.secondaryGrayLightThree};
  margin: 1em 2vw 1em 1em;
  padding: 1em;
`;

export const ContentAnswer = styled.div`
  background-color: ${({ theme }) => theme.neutral.white};
  border-radius: 4px;
  padding: 2em;
  margin: 2em 0em;
  p:nth-child(1) {
    font-size: 16px;
    font-weight: 600;
    text-align: initial;
    margin: 9px 0;
  }
  p:nth-child(2) {
    background: ${({ theme }) => theme.neutral.gray[400]};
    border-radius: 3px;
    padding: 0.3em 1.5em;
    text-align: initial;
    display: flex;
    align-items: center;
    min-height: 40px;
  }
`;

export const RowForm = styled.div`
  display: flex;
  justify-content: space-around;
  flex-direction: row;
  width: fit-content;
  margin: 1em 0;
`;

export const ColContent = styled.div`
  display: flex;
  flex-direction: column;
  #comment-description {
    font-size: 12px;
    background-color: #d9d9d980;
    width: 15vw;
    height: 51px;
    border-radius: 10px;
    padding: 0px 9px;
  }
`;

export const ContentProfile = styled.div`
  width: 3em;
  height: 3em;
`;

export const ContentCommentProfile = styled.div`
  margin: ${({ idCaseComment }) => (idCaseComment ? "1em 0em 0em" : "inherit")};
  width: 3em;
  height: 3em;
`;

export const ImgProfile = styled.img`
  width: 2em;
  height: 2em;
  border-radius: 99px;
`;

export const ContentUpdateButton = styled.div`
  display: flex;
  justify-content: center;
  flex-direction: row;
`;

export const ButtonDone = styled.button`
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  width: 114px;
  height: 36px;
    background: ${({ theme }) => theme.button.primary};
  border-radius: 4px;
  border: none;
  margin: 1em auto;
  color: white;
  font-size: 14px;
  &:hover {
    box-shadow: ${({ theme }) => theme.button.buttonHoverShadow};
    transform: translateY(-1px);
    cursor: pointer;
  }
  a {
    color: ${({ theme }) => theme.neutral.gray[200]};
    text-decoration: none;
    background-color: transparent;
  }
  &:disabled {
    opacity: 0.5;
  }
`;

export const FileUpload = styled.input`
  visibility: hidden;
  height: 0;
  width: 0;
`;

export const ContentAttachment = styled.div`
  display: grid;
  grid-template-columns: 27vw;
  background-color: white;
`;

export const CardContainer = styled.div`
  margin: 1em 0em 0em 4em;
  width: 20.0625em;
  height: 4.8125em;
  background-color: ${({ theme }) => theme.primaryBackgroundLight};
  box-shadow: 0px 2px 8px rgba(46, 46, 46, 0.1);
  border: 1px solid ${({ theme }) => theme.neutral.gray[700]};
  border-radius: 3px;
  cursor: pointer;
  display: grid;
  grid-template-columns: 5vw 1fr;
  justify-content: center;
  align-items: center;
  &:hover {
    box-shadow: 0px 2px 8px rgba(0, 0, 0, 0.3);
    transition: 0.5s;
    transform: translate(-3px, -3px);
  }
`;

export const ContentImgCard = styled.div`
  margin: 0em 0.4em;
`;

export const ContentTextCard = styled.div``;

export const ImgAttach = styled.img`
  width: 54px;
  height: auto;
`;

export const FileSizeText = styled.span`
  font-size: 15px;
  color: ${({ theme }) => theme.secondaryDarkOne};
`;

export const DownloadLink = styled.a`
  font-size: 12px;
  color: ${({ theme }) => theme.secondaryDarkOne};
  &:hover {
    color: ${({ theme }) => theme.button.primary};
    cursor: pointer;
  }
`;

export const TitleCard = styled.div`
  font-size: 15px;
  font-weight: 600;
  color: ${({ theme }) => theme.secondaryDarkOne};
`;
